// extracted by mini-css-extract-plugin
export var blogPostMainImg = "blog-post-module--blogPostMainImg--oWx0Z";
export var blogPostTitle = "blog-post-module--blogPostTitle--06QWp";
export var blogPostCategories = "blog-post-module--blogPostCategories--w7sER";
export var blogPostCategoriesUL = "blog-post-module--blogPostCategoriesUL--8MOrC";
export var categoriesHeadline = "blog-post-module--categoriesHeadline--aWVrh";
export var blogPostDate = "blog-post-module--blogPostDate--h8uMT";
export var gatsbyImageWrapperConstrained = "blog-post-module--gatsby-image-wrapper-constrained--GouTp";